import { 
    gql, 
    useQuery 
} from "@apollo/client";
import {FindAllCustomerTiersData, FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables } from "../../../../../../schemaTypes";

export const findCustomerTierByIdQuery = gql`
  query FindCustomerTierByIdQuery($id: String!) {
    findCustomerTierById(id: $id) {
        id
        name
        multiplier
        threshold
        createdAt
        customerCount
        isArchive
    }
  }
`;

export function useFindCustomerTierById(id: string) {
  const { data, loading, error } = useQuery<
    FindCustomerTierByIdQueryQuery,
    FindCustomerTierByIdQueryQueryVariables
  >(findCustomerTierByIdQuery, {
    variables: { id },
    skip: !id,
  });

  return {
    customerTier: data?.findCustomerTierById as FindAllCustomerTiersData | undefined,
    loading,
    error
  };
}